var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentVoilet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4585 0.666992H2.50016C2.19074 0.666992 1.894 0.789908 1.6752 1.0087C1.45641 1.22749 1.3335 1.52424 1.3335 1.83366V11.167C1.3335 11.4764 1.45641 11.7732 1.6752 11.992C1.894 12.2107 2.19074 12.3337 2.50016 12.3337H9.50016C9.80958 12.3337 10.1063 12.2107 10.3251 11.992C10.5439 11.7732 10.6668 11.4764 10.6668 11.167V3.87533L7.4585 0.666992Z",
    stroke: "#714FFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentVoilet);
export default __webpack_public_path__ + "static/media/document-voilet.77c419758a95d9b556081cbf4f434fbb.svg";
export { ForwardRef as ReactComponent };